// MODEL : instance of Column

define('app/editor/ColumnOptionsView',['require','glu/itemView','app/config/aggregateOptions','config','glu/$','glu/util','hbs!./ColumnOptionsView.hbs','glu/dialog'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		AGGREGATE_OPTIONS = require('app/config/aggregateOptions'),
		config = require('config'),
		$ = require('glu/$'),
		_ = require('glu/util'),
		tmpl = require('hbs!./ColumnOptionsView.hbs'),
		dialog = require('glu/dialog');

	return ItemView.extend({
		template: tmpl,

		getClass: function() {
			return 'modal-edit-aggregation';
		},

		ui: {
			$aggregationOptions: '.select-box',
			$aggregation: '[name=aggregation]',
			$percentage: '[name=percentage]',
			$asName: '[name=asName]',
			$fieldName: '.column-option-field-name',
			$errorMsg: '[id=errorMsg]',
			$viewDataAs: '[name=viewDataAs]'
		},

		dialogTitle: 'Column Options',

		dialogButtons: [{
			text: 'Save',
			callback: 'save',
			className: 'btn-primary'
		}],

		events: {
			'change .select-box': 'resetAggregation',
			'change  [name=asName]': 'onAsName',
			'change  input[name=viewDataAs]': 'onViewDataAs',
			'keyup  [name=asName]': 'onAsName'
		},

		initialize: function() {
			var self = this;

			this.origAsName = _.clone(this.model.get('asName'));

			if (this.isAggregate()) {
				window.setTimeout(function() {
					self.$el.find('.aggregate-options').addClass('active');
				}, 0);
			}

			if (this.options.report.get('domain') && this.options.report.get('domain').getTimespanOptions) {
				this.timespanOptions = this.options.report.get('domain').getTimespanOptions();
			}
		},

		resetAggregation: function() {
			if (!this.asNameDirty) {
				this.ui.$asName.val(this.ui.$aggregation.val() + '(' + this.ui.$fieldName.text() + ')');
			}

			this.evalPercentage();
		},

		onRender: function() {
			this.ui.$aggregationOptions.comboBox();
			this.evalPercentage();

			if (this.isVirtualColumn()) {
				this.setArgumentValues();
			}
		},

		aggregateOptions: function() {
			var currentOption = this.model.getAggregation();
			var options = AGGREGATE_OPTIONS[this.model.getField().isMeasure() ? 'MEASURE' : 'DIMENSION'];
			return options.map(function(o) {
				return {
					label: o.label,
					value: o.value,
					isSelected: currentOption === o.value
				};
			});
		},

		evalPercentage: function() {
			var val = this.ui.$aggregation.val();
			if (val === 'SUM' || val === 'COUNT' || val === 'COUNTD') {
				this.ui.$percentage.prop('disabled', false);
			} else {
				this.model.setPercentage(false);
				this.ui.$percentage.prop('checked', false);
				this.ui.$percentage.prop('disabled', true);
			}
		},

		alias: function() {
			return this.model.displayName();
		},

		isPercentage: function() {
			return this.model.isPercentage();
		},

		isAggregate: function() {
			return this.model.hasAggregation();
		},

		isGroupedAndAggregated: function() {
			return this.options.report.isGroupedAndAggregated();
		},

		showAggregateOptions: function() {

		},

		serializeData: function() {
			return this;
		},

		fieldName: function() {
			return this.model.fieldName();
		},

		fieldDescription: function() {
			return this.model.fieldDescription();
		},

		fieldQualifiedName: function() {
			return this.model.fieldQualifiedName();
		},

		isValid: function() {
			var val = this.ui.$asName.val();
			var isValid = config.textRegex.test(val);

			return !!isValid;
		},

		toIteration: function(i) {
			return i + 1;
		},

		isVirtualColumn: function() {
			return this.model.get('columnType') === 'FUNCTION';
		},

		setArgumentValues: function() {
			for (var i = 0; i < this.model.get('funcArguments').length; i++) {
				this.$el.find('#argument' + i).val(this.model.get('funcArguments')[i].fieldId);
			}
		},

		virtualColumnArguments: function() {
			return this.model.get('funcArguments');
		},

		measureOrDimension: function() {
			if (this.model.isMeasure()) {
				return 'Measure';
			} else if (this.model.isDimension()) {
				return 'Dimension';
			}
		},

		onAsName: function() {

			// validate the input: ONLY alphanumeric, space, - , . ' ( ) _ " ? : ; @
			var isValid = this.isValid();

			this.asNameDirty = true;

			if (isValid) {
				this.ui.$asName.removeClass('input-dialog-item-error');
				this.ui.$errorMsg.hide();
			} else {
				this.ui.$asName.addClass('input-dialog-item-error');
				this.ui.$errorMsg.show();
			}
		},

		onViewDataAs: function(e) {
			this.model.viewDataAs = $(e.target).val();

			if (!this.asNameDirty) {
				this.ui.$asName.val(this.ui.$fieldName.text());
			}

			if (this.model.viewDataAs === 'aggregate') {
				this.$el.find('.aggregate-options').addClass('active');
				this.resetAggregation();
			} else {
				this.$el.find('.aggregate-options').removeClass('active');
			}
		},

		save: function() {
			var self = this;

			if (self.isValid()) {
				var viewDataAs = self.model.viewDataAs;

				if (self.asNameDirty) {
					self.model.setManualAsName(true);
				}

				var asName = self.ui.$asName.val();
				self.model.setAsName(asName);

				// Switch between group, aggregate, and disabled
				if (viewDataAs) {
					if (viewDataAs === 'aggregate' && !self.model.hasAggregation()) {
						// Enable aggregation mode if it isn't already enabled
						if (!self.options.report.hasAggregateColumns() && !$('#group-and-aggregate-checkbox').prop('checked')) {
							self.options.report.setGroupedAndAggregated(true);
							$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
						}

						// Move to aggregate column
						self.options.report.moveColumnToCategory(self.model.cid, 'aggregated');
					}
					if (viewDataAs === 'group' && (self.model.hasAggregation() || !self.options.report.isGroupedAndAggregated())) {
						if (!self.options.report.hasAggregateColumns() && !$('#group-and-aggregate-checkbox').prop('checked')) {
							self.options.report.setGroupedAndAggregated(true);
							self.options.report.setAllColumnsToAggregate();

							$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
						}

						// Move to group column
						self.options.report.moveColumnToCategory(self.model.cid, 'grouped');
					}
					if (viewDataAs === 'disableGroupAndAggregate' && self.options.report.isGroupedAndAggregated()) {
						self.options.report.setGroupedAndAggregated(false);
						$('#report-definition').children().first().toggleClass('is-grouping-hidden', true);
					}
				}

				if (self.model.hasAggregation()) {
					var aggregation = self.ui.$aggregation.val();
					self.model.setAggregation(aggregation);

					var isPercentage = self.ui.$percentage.is(':checked');
					self.model.setPercentage(isPercentage);
				}

				if (this.isVirtualColumn()) {
					for (var i = 0; i < this.model.get('funcArguments').length; i++) {
						this.model.get('funcArguments')[i].fieldId = this.$el.find('#argument' + i).val();
						this.model.get('funcArguments')[i].name = this.$el.find('#argument' + i + ' option:selected').text();
					}
				}

				dialog.close();
				self.appBus.trigger('refresh');
			}
		}

	});

});

